import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DrawerModule } from 'primeng/drawer';

export interface SynergyDetailData {
  id: number;
  title: string;
  description: string;
  category: string;
  status: string;
  hub_1: {
    id: number;
    name: string;
    city: string;
    avatar?: string;
  };
  hub_2: {
    id: number;
    name: string;
    city: string;
    avatar?: string;
  };
  potential_benefits: string[];
  created_at: string;
  activated_at?: string;
}

@Component({
  selector: 'app-synergy-detail-sheet',
  standalone: true,
  imports: [CommonModule, DrawerModule],
  templateUrl: './synergy-detail-sheet.component.html',
  styleUrls: ['./synergy-detail-sheet.component.scss']
})
export class SynergyDetailSheetComponent implements OnChanges {
  @Input() synergy: SynergyDetailData | null = null;
  @Input() isOpen = false;
  @Input() isDesktop = false;

  @Output() close = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges): void {
    // Handle visibility changes if needed
  }

  constructor(private router: Router) {}

  onClose(): void {
    this.close.emit();
  }

  onVisibleChange(visible: boolean): void {
    if (!visible) {
      this.close.emit();
    }
  }

  onAvatarClick(hubId: number, event: Event): void {
    event.stopPropagation();
    this.close.emit();
    this.router.navigate(['/dashboard/partners', hubId]);
  }

  getCategoryLabel(category: string): string {
    const labels: { [key: string]: string } = {
      'supply-chain': 'Supply Chain',
      'energy': 'Energie',
      'mobility': 'Mobilität',
      'innovation': 'Innovation',
      'service': 'Service',
      'marketing': 'Marketing',
      'resources': 'Ressourcen'
    };
    return labels[category] || category;
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('de-DE', { month: 'long', year: 'numeric' });
  }
}
